const TEST_KEY = '__storage_test__';

class LocalStorage {
    private static readonly available: boolean = (() => {
        try {
            localStorage.setItem(TEST_KEY, TEST_KEY);
            localStorage.removeItem(TEST_KEY);
            return true;
        } catch {
            return false;
        }
    })();

    public static get<T = unknown>(key: string): T | null {
        if (!this.available) {
            return null;
        }

        try {
            const item = localStorage.getItem(key);
            if (item === null) {
                return null;
            }
            return JSON.parse(item) as T;
        } catch {
            return null;
        }
    }

    public static set(key: string, value: unknown): void {
        if (!this.available) {
            console.error('LocalStorage is not available');
            return;
        }

        try {
            const serialized = JSON.stringify(value);
            localStorage.setItem(key, serialized);
        } catch (error) {
            console.error('Failed to set item in LocalStorage:', error);
        }
    }

    public static remove(key: string): boolean {
        if (!this.available) {
            return false;
        }

        try {
            localStorage.removeItem(key);
            return true;
        } catch {
            return false;
        }
    }

    public static clear(): boolean {
        if (!this.available) {
            return false;
        }

        try {
            localStorage.clear();
            return true;
        } catch {
            return false;
        }
    }
}

export default LocalStorage;
